(function() {
  const modal = document.getElementById('meadModal');
  const modalOverlay = modal.querySelector('.modal-overlay');
  const modalClose = modal.querySelector('.modal-close');
  const flipCards = document.querySelectorAll('.mead-flip-card');
  
  const modalLabelImg = document.getElementById('modalLabelImg');
  const modalBottleImg = document.getElementById('modalBottleImg');
  const modalTitle = document.getElementById('modalTitle');
  const modalDescription = document.getElementById('modalDescription');
  
  const carouselSlides = modal.querySelectorAll('.carousel-slide');
  const prevBtn = modal.querySelector('.carousel-prev');
  const nextBtn = modal.querySelector('.carousel-next');
  const carouselContainer = modal.querySelector('.modal-carousel');

  let currentSlide = 0;

  // Add loaded class to images when they finish loading
  document.querySelectorAll('.mead-flip-card img').forEach(img => {
    if (img.complete) {
      img.classList.add('loaded');
    } else {
      img.addEventListener('load', function() {
        this.classList.add('loaded');
      });
    }
  });

  // Create carousel indicators
  const indicatorsContainer = document.createElement('div');
  indicatorsContainer.className = 'carousel-indicators';

  const indicators = [];
  for (let i = 0; i < carouselSlides.length; i++) {
    const indicator = document.createElement('div');
    indicator.className = 'carousel-indicator';
    indicator.addEventListener('click', function() {
      currentSlide = i;
      updateCarousel();
    });
    indicators.push(indicator);
    indicatorsContainer.appendChild(indicator);
  }

  carouselContainer.appendChild(indicatorsContainer);
  
  // Mead data (sorted alphabetically)
  const meadsData = [
    { name: "Apple Mead", abv: "6.5%", availability: "All year", labelDesign: "@an_anandrk", description: "Made using Multifloral Honey & Kashmiri Apples, this Mead is a semi‑dry Mead, perfect for a sunny afternoon ☀️" },
    { name: "Bourbon Oaked Apple Mead", abv: "6.5%", availability: "Seasonal", labelDesign: "@bhattchin", description: "Made by ageing our Apple Mead over bourbon infused French oak chips, this Mead has a subtle honey backbone with a mild bourbon finish & hints of oak on the after palate 🥃" },
    { name: "Chocolate Orange Mead", abv: "6.5%", availability: "Seasonal", labelDesign: "@nikhil_more", description: "Made using Orange Blossom Honey, orange peels, cacao husk & cocoa powder. This Mead is a delightful pop of flavour 🍊🍫" },
    { name: "Christmas Apple Pie Mead", abv: "6.5%", availability: "Seasonal", labelDesign: "@asdswow", description: "Made using Kashmiri Apples, Cinnamon, Nutmeg, Cloves, & rum soaked raisins ‑ this Mead is Christmas in a bottle 🎄" },
    { name: "Coffee Mead", abv: "6.5%", availability: "Seasonal", labelDesign: "@thebigfatminimalist", description: "Made using Multifloral Honey and a blend of cold brewed Arabica & Robusta beans, this Mead is a treat for Coffee lovers ☕️" },
    { name: "Grilled Pineapple Mead", abv: "6.5%", availability: "Seasonal", labelDesign: "@karanleomes", description: "Made using Multifloral Honey & spiced rum-soaked pineapples grilled over coal, this Mead is a one-way ticket to the Caribbean 🍍🏖" },
    { name: "Guava Chilli Mead", abv: "6.5%", availability: "Seasonal", labelDesign: "@saahir_shetty", description: "Made using Multifloral Honey, pink and white guavas & Naga ghost chillies, this Mead is a tropical delight with fruity guavas on the front palate & subtle heat on the after palate 🌶" },
    { name: "Hibiscus Ginger Mead", abv: "6.5%", availability: "Seasonal", labelDesign: "@the.world.through.my.stylus", description: "Made using Multifloral Honey, dried hibiscus flowers & fresh ginger. Bright, floral acidity upfront with a gentle warmth on the finish. It's refreshing, balanced, and quietly complex 🌺" },
    { name: "Hopped Mead", abv: "6.5%", availability: "Seasonal", labelDesign: "@the.inkpot", description: "Mild sweetness from the Multifloral Honey followed by fruitiness & a lingering bitterness from the Hops. The bitterness and hoppiness of an IPA, without the bloating that gluten brings!" },
    { name: "Lemon Tea Mead", abv: "4.5%", availability: "All year", labelDesign: "@niharika.kapil", description: "Made using Multifloral Honey, Vahdam Earl grey tea & fresh lemon zest. Light, crisp, and gently tannic. This mead drinks like a chilled afternoon tea with a citrus lift 🍋🍃" },
    { name: "Mango Chilli Mead", abv: "6.5%", availability: "Seasonal", labelDesign: "@mr.raulmaniac", description: "Made using Multifloral Honey, Kesar Mangoes & Guntur chillies ‑ this Mead is a summertime classic 🥭🌶" },
    { name: "Mixed Berry Mead", abv: "4.5%", availability: "All year", labelDesign: "@niharika.kapil", description: "Made using Multifloral Honey and a blend of seasonal berries, you name it! Juicy and fruit-forward with a soft sweetness, this mead is easy drinking and crowd-pleasing 🍓🫐" },
    { name: "Moonshine × Subko Coffee Mead", abv: "6.5%", availability: "Limited", labelDesign: "Subko", description: "A small batch, limited edition Mead made in collaboration with Subko. Crafted using Multifloral Honey and Subko's specialty coffee, cold brewed to highlight nuanced roast character where honeyed sweetness meets refined coffee depth ☕️" },
    { name: "Project X Mead", abv: "6.5%", availability: "Seasonal", labelDesign: "@junglegymstudio", description: "A small batch, limited edition Mead made from single origin honey sourced through the Moonshine Honey Project." },
    { name: "Salted Kokum Mead", abv: "6.5%", availability: "Seasonal", labelDesign: "@enthu_nugget", description: "A hit of fresh Kokum that makes your mouth pucker, balanced out by pink salt, with an undertone of ginger married together by sweet honey. This Mead always leaves you pining for more." },
    { name: "Spiced Pumpkin Mead", abv: "6.5%", availability: "Seasonal", labelDesign: "@thisthataandtheother", description: "Made using Multifloral Honey, roasted pumpkin & warm baking spices. Smooth, gently spiced, and comforting, this Mead is autumn in a glass 🎃" },
    { name: "Thai Ginger and Kaffir Lime Mead", abv: "6.5%", availability: "Seasonal", labelDesign: "@nupurfireworks", description: "The freshness of Kaffir Lime and a symphony of the sweetness from honey and mellow heat from the Ginger - If you appreciate South East Asian cuisine, this Mead is for you! 🍃" },
    { name: "Traditional Mead", abv: "6.5%", availability: "Seasonal", labelDesign: "@nikhil_more", description: "Made using Multifloral, Acacia, Sidr & Mustard Honey ‑ this Mead is floral & easy going." },
  ];
  
  // Open modal only when clicking on the flipped (back) side
  flipCards.forEach((card, index) => {
    card.addEventListener('click', function(e) {
      // Only open modal if the card is currently showing the back (bottle)
      const inner = this.querySelector('.flip-card-inner');
      const isFlipped = window.getComputedStyle(inner).transform !== 'none';
      
      if (!isFlipped) return; // Don't open modal if showing label
      
      const meadData = meadsData[index] || meadsData[0];
      
      // Use popup-specific images from the global object set by Liquid
      const popupImages = window.meadPopupImages && window.meadPopupImages[meadData.name];
      
      if (popupImages) {
        // Remove loaded class first to show skeleton
        modalLabelImg.classList.remove('loaded');
        modalBottleImg.classList.remove('loaded');
        
        // Set new image sources
        modalLabelImg.src = popupImages.label;
        modalBottleImg.src = popupImages.bottle;
        
        // Add loaded class when images finish loading
        if (modalLabelImg.complete) {
          modalLabelImg.classList.add('loaded');
        } else {
          modalLabelImg.onload = function() {
            this.classList.add('loaded');
          };
        }
        
        if (modalBottleImg.complete) {
          modalBottleImg.classList.add('loaded');
        } else {
          modalBottleImg.onload = function() {
            this.classList.add('loaded');
          };
        }
      }
      
      // Set text content
      modalTitle.textContent = meadData.name;
      modalDescription.innerHTML = `
        <p>${meadData.description}</p>
        <p>ABV: ${meadData.abv}</p>
        <p>Availability: ${meadData.availability}</p>
        <p>Label Design: ${meadData.labelDesign}</p>
      `;
      
      // Reset carousel
      currentSlide = 0;
      updateCarousel();
      
      // Open modal
      modal.classList.add('active');
      modal.scrollTop = 0;
      document.body.style.overflow = 'hidden';
    });
  });
  
  // Close modal
  function closeModal() {
    modal.classList.remove('active');
    document.body.style.overflow = '';
  }
  
  modalClose.addEventListener('click', closeModal);
  modalOverlay.addEventListener('click', closeModal);
  
  // Carousel navigation
  function updateCarousel() {
    carouselSlides.forEach((slide, index) => {
      slide.classList.toggle('active', index === currentSlide);
    });

    // Update indicators
    indicators.forEach((indicator, index) => {
      indicator.classList.toggle('active', index === currentSlide);
    });

    // Show/hide arrows based on current slide
    // Slide 0 = Label (show only right arrow)
    // Slide 1 = Bottle (show only left arrow)
    if (currentSlide === 0) {
      prevBtn.style.display = 'none';
      nextBtn.style.display = 'flex';
    } else {
      prevBtn.style.display = 'flex';
      nextBtn.style.display = 'none';
    }
  }
  
  nextBtn.addEventListener('click', function() {
    currentSlide = (currentSlide + 1) % carouselSlides.length;
    updateCarousel();
  });
  
  prevBtn.addEventListener('click', function() {
    currentSlide = (currentSlide - 1 + carouselSlides.length) % carouselSlides.length;
    updateCarousel();
  });
  
  // Keyboard navigation
  document.addEventListener('keydown', function(e) {
    if (!modal.classList.contains('active')) return;
    
    if (e.key === 'Escape') closeModal();
    if (e.key === 'ArrowRight') nextBtn.click();
    if (e.key === 'ArrowLeft') prevBtn.click();
  });
})();